import axios from "axios";


const BACKEND_URL =
  process.env.REACT_APP_BACKEND_URL || "http://localhost:8000";
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API,
    withCredentials: true,
});

export const getSharedWorkspace = async ({
    childId,
    scope,
    workspaceType,
}) => {
    const response = await api.get(
        `/children/${encodeURIComponent(
            childId
        )}/shared-workspaces/${encodeURIComponent(
            scope
        )}/${encodeURIComponent(
            workspaceType
        )}`
    );

    return response.data;
};

export const saveSharedWorkspace = async ({
    childId,
    scope,
    workspaceType,
    workspace,
}) => {
    const response = await api.put(
        `/children/${encodeURIComponent(
            childId
        )}/shared-workspaces/${encodeURIComponent(
            scope
        )}/${encodeURIComponent(
            workspaceType
        )}`,
        workspace
    );

    return response.data;
};

export const APP_NAME = "Shadow Grove Coven Familiars";

export const levelMeta = {
    4: { name: "Fully Bonded", tagline: "Magic is humming", color: "#3a86ff" },
    3: { name: "Warning", tagline: "Bond is fading", color: "#7cc1ff" },
    2: { name: "Fading", tagline: "Drifting away", color: "#7cc1ff" },
    1: { name: "Spirit Form", tagline: "Far, far away", color: "#7cc1ff" },
};

export function pointsToLevel(p) {
    if (p >= 300) return 4;
    if (p >= 200) return 3;
    if (p >= 100) return 2;
    return 1;
}

// Map celebration name -> CSS class on Blueberry
export const celebrateClass = {
    dance: "bb-celebrate-dance",
    backflip: "bb-celebrate-backflip",
    spin: "bb-celebrate-spin",
    bounce: "bb-celebrate-bounce",
    twirl: "bb-celebrate-twirl",
};
